import { useState, useEffect } from 'react';

export interface ProjectLog {
  id: string;
  time: string;
  user: {
    name: string;
    avatar: string;
    role: string;
  };
  action: string;
  actionColor: string;
  content: string;
  target: {
    type: string;
    name: string;
  };
  detail: string;
  icon: string;
  iconColor: string;
  iconBg: string;
}

export function useProjectLogs() {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setData({
        summary: [
          { label: 'Tổng hoạt động', value: 245, icon: 'ri-history-line', color: 'text-amber-500', bg: 'bg-amber-50' },
          { label: 'Hôm nay', value: 18, icon: 'ri-calendar-check-line', color: 'text-emerald-500', bg: 'bg-emerald-50' },
          { label: 'Tuần này', value: 62, icon: 'ri-calendar-2-line', color: 'text-blue-500', bg: 'bg-blue-50' },
          { label: 'Tháng này', value: 245, icon: 'ri-calendar-todo-line', color: 'text-sky-500', bg: 'bg-sky-50' },
        ],
        logs: [
          { id: '1', time: '30/05/2024 10:30', user: { name: 'Nguyễn Văn An', role: 'Quản lý dự án', avatar: 'https://i.pravatar.cc/150?u=4' }, action: 'Cập nhật công việc', actionColor: 'bg-emerald-50 text-emerald-600', content: 'Cập nhật tiến độ công việc "Thi công móng hầm"', target: { type: 'Công việc', name: 'Thi công móng hầm' }, detail: 'Tiến độ: 65% → 70%', icon: 'ri-task-line', iconColor: 'text-emerald-500', iconBg: 'bg-emerald-50' },
          { id: '2', time: '30/05/2024 09:15', user: { name: 'Trần Thị Mai', role: 'Kỹ sư hiện trường', avatar: 'https://i.pravatar.cc/150?u=11' }, action: 'Thêm tài liệu', actionColor: 'bg-blue-50 text-blue-600', content: 'Tải lên tài liệu mới "Biên bản nghiệm thu móng hầm"', target: { type: 'Tài liệu', name: 'Biên bản nghiệm thu móng hầm' }, detail: 'Dung lượng: 2.4 MB', icon: 'ri-file-text-line', iconColor: 'text-blue-500', iconBg: 'bg-blue-50' },
          { id: '3', time: '29/05/2024 16:45', user: { name: 'Lê Hoàng Nam', role: 'Giám sát kỹ thuật', avatar: 'https://i.pravatar.cc/150?u=2' }, action: 'Phê duyệt', actionColor: 'bg-emerald-50 text-emerald-600', content: 'Phê duyệt yêu cầu vật tư "Thép xây dựng D16"', target: { type: 'Yêu cầu vật tư', name: 'REQ-2024-015' }, detail: 'Số lượng: 12.000 kg', icon: 'ri-checkbox-circle-line', iconColor: 'text-emerald-600', iconBg: 'bg-emerald-50' },
          { id: '4', time: '29/05/2024 14:22', user: { name: 'Phạm Văn Tài', role: 'Giám sát hiện trường', avatar: 'https://i.pravatar.cc/150?u=3' }, action: 'Tạo công việc', actionColor: 'bg-purple-50 text-purple-600', content: 'Tạo công việc mới "Lắp đặt cốt thép sàn tầng 2"', target: { type: 'Công việc', name: 'Lắp đặt cốt thép sàn tầng 2' }, detail: 'Hạn hoàn thành: 05/06/2024', icon: 'ri-add-box-line', iconColor: 'text-purple-500', iconBg: 'bg-purple-50' },
          { id: '5', time: '28/05/2024 11:08', user: { name: 'Vũ Thị Thanh', role: 'Kế toán dự án', avatar: 'https://i.pravatar.cc/150?u=12' }, action: 'Thanh toán', actionColor: 'bg-amber-50 text-amber-600', content: 'Thanh toán chi phí "Thanh toán đợt 3 cho NCC An Phát"', target: { type: 'Chi phí', name: 'Thanh toán đợt 3' }, detail: 'Số tiền: 850.000.000 VND', icon: 'ri-money-dollar-circle-line', iconColor: 'text-amber-500', iconBg: 'bg-amber-50' },
        ]
      });
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return { data, isLoading };
}
